<ng-container *ngIf="imageModalService.isModalEdit$ | async">
  <app-edit-capture (fileFinished)="onConfirmEvent($event)" (closeModal)="onCancelEvent()"></app-edit-capture>
</ng-container>
